/**
 * @generated SignedSource<<5de776fd06dc4f3b32e6bbfba7f1ef8e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Plans$data = {
  readonly jira: {
    readonly advancedRoadmapsNavigation: {
      readonly hasCreateSamplePlanPermissions: boolean | null | undefined;
      readonly hasEditPermissions: boolean | null | undefined;
      readonly hasGlobalPlansAdminPermissions: boolean | null | undefined;
    } | null | undefined;
    readonly hasIsPlansExpanded?: "JiraQuery";
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4PlansForLanding">;
  readonly " $fragmentType": "Nav4Plans";
};
export type Nav4Plans$key = {
  readonly " $data"?: Nav4Plans$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Plans">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "isPlansExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Plans",
  "selections": [
    {
      "condition": "isPlansExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "Nav4PlansForLanding"
        }
      ]
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "isPlansExpanded",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "hasIsPlansExpanded",
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraAdvancedRoadmapsNavigation",
          "kind": "LinkedField",
          "name": "advancedRoadmapsNavigation",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasEditPermissions"
            },
            {
              "kind": "ScalarField",
              "name": "hasCreateSamplePlanPermissions"
            },
            {
              "kind": "ScalarField",
              "name": "hasGlobalPlansAdminPermissions"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "d94bdd2f938a10104ed5834debf9b43c";

export default node;
